var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-autocomplete',{staticClass:"gmaps-autocomplete",attrs:{"options":_vm.options,"value":_vm.value,"placeholder":_vm.placeholder || ''},on:{"place_changed":_vm.setPlace}})}
var staticRenderFns = []

export { render, staticRenderFns }